const phasesConfig: Record<string, {
    scale: number;
    translateX: number;
    translateY: number
}> = {
    karambit: {scale: 15, translateX: 10, translateY: 24},
    butterfly: {scale: 15, translateX: 26, translateY: 19},
    daggers: {scale: 15, translateX: 6, translateY: 16},
    // bowie: {scale: 15, translateX: 15, translateY: 5},
    // m9: {scale: 15, translateX: 15, translateY: 5},
    // // bayonet: {scale: 15, translateX: 15, translateY: 5},
    flip: {scale: 15, translateX: 10, translateY: 3},
    gut: {scale: 15, translateX: 15, translateY: 10},
    // shadow: {scale: 15, translateX: 15, translateY: 5},
    // huntsman: {scale: 15, translateX: 15, translateY: 5},
    falchion: {scale: 15, translateX: 15, translateY: 15},
    navaja: {scale: 15, translateX: 15, translateY: 16},
    stiletto: {scale: 25, translateX: 15, translateY: 10},
    talon: {scale: 15, translateX: 13, translateY: 22},
    ursus: {scale: 15, translateX: 15, translateY: 10},
    // classic: {scale: 15, translateX: 15, translateY: 5},
    // paracord: {scale: 15, translateX: 15, translateY: 5},
    skeleton: {scale: 17, translateX: 25, translateY: 20},
    // survival: {scale: 15, translateX: 15, translateY: 5},
    nomad: {scale: 15, translateX: 15, translateY: 13},
    glock: {scale: 15, translateX: -14, translateY: 17},

    default: {scale: 15, translateX: 0, translateY: 0}
};

export default phasesConfig;
